var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticStyle:{"position":"relative"},attrs:{"name":_vm.name,"tag":_vm.tag,"enter-active-class":_vm.enterClasses,"leave-active-class":_vm.leaveClasses,"move-class":(_vm.name + "-move")}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }